import { FONT } from './font';

export default function buildTableStyles(colors) {
  const { colorShades, tableBorderColor, text, primary } = colors;

  return {
    MuiTable: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: colorShades.pureWhite,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '& th:last-child, & td:last-child': {
            overflow: 'hidden',
          },
        },
        head: {
          backgroundColor: primary.veryLight,
          boxShadow: '0px 4px 6px -5px rgba(0, 0, 0, 0.2)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderWidth: '1px',
          borderColor: tableBorderColor || colorShades.mediumGrey,
          color: text.primary,
        },
        head: {
          fontSize: '0.9rem',
          fontFamily: FONT.w500,
          height: '40px',
          color: text.primary,
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '12px',
          },
        },
      },
    },
  };
}
